// extracted by mini-css-extract-plugin
export default {"patientSignup":"patientSignupp_patientSignup__HYNhC","inputs":"patientSignupp_inputs__3mlba","sam":"patientSignupp_sam__9y1Jn","mobileNoSec":"patientSignupp_mobileNoSec__6EkWo"};